import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClientService } from '../services/http-client.service';
import { CookieNames, ApiEndpoints ,BasicRoutes} from '../../core-modules/constant';

@Component({
  selector: 'app-error-internet',
  templateUrl: './error-internet.component.html',
  styleUrls: ['./error-internet.component.css', '../../css/paper-sets.component.css']
})
export class ErrorInternetComponent implements OnInit {
  constructor(
    private router: Router,
    private httpClientService : HttpClientService) { }

  ngOnInit() {
    this.apiAvailability();
  }

  apiAvailability() {
    let interval = setInterval(() => {
        this.httpClientService.get(ApiEndpoints.BASE_URL).subscribe(
          sucess => {
            clearInterval(interval);
            this.router.navigate([BasicRoutes.clientExams]);
          }
        );
      }, 3000);
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/error-internet/error-internet.component.ts